import { Module } from 'vuex-smart-module';
import UserActions from './actions';
import UserGetters from './getters';
import UserMutations from './mutations';
import UserState from './state';

export default new Module({
  state: UserState,
  mutations: UserMutations,
  actions: UserActions,
  getters: UserGetters,
});
